import React from 'react';
import { Button } from '../ui/button';
import { Shuffle, RotateCcw } from 'lucide-react';
import { GAME_STATES } from '../../mock/gameData';

const GameControls = ({ gameState, onStartGame }) => {
  if (gameState !== GAME_STATES.WAITING && gameState !== GAME_STATES.GAME_OVER) {
    return null;
  }

  return (
    <div className="flex justify-center">
      <Button 
        onClick={onStartGame}
        size="lg"
        className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 text-lg font-semibold"
      >
        {gameState === GAME_STATES.WAITING ? (
          <>
            <Shuffle className="w-5 h-5 mr-2" />
            Deal Cards
          </>
        ) : (
          <>
            <RotateCcw className="w-5 h-5 mr-2" />
            New Game
          </>
        )}
      </Button>
    </div>
  );
};

export default GameControls;